import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SideNavComponent } from '@bo-client/core/navigation/side-nav/side-nav.component';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {
  @ViewChild('scrollContainer')
  scrollContainer: ElementRef;

  @ViewChild(SideNavComponent)
  sideNavComponent: SideNavComponent;

  public menuExpanded: boolean;

  constructor() {}

  ngOnInit(): void {}
  onMenuSizeChanged($event: any) {
    this.menuExpanded = $event;
  }

  mainOverlayClicked() {
    this.sideNavComponent.toggleMenu();
  }
}
